import { BASE_URL,APPLICATION_BASEURL} from "../assets/config.json"
export const environment = {
    production: false,
     BASE_URL: BASE_URL,
      APPLICATION_BASEURL:APPLICATION_BASEURL,

}